module.exports = __webpack_public_path__ + "static/media/detail_0041_t.d53ad26f.jpg";